module.exports = __webpack_public_path__ + "static/media/iconFile.02d8785b.svg";